import { createContext } from "svelte";

export const [getConfiguratorState, setConfiguratorState] = createContext<{ open: boolean }>();
